export const API_URL = process.env.REACT_APP_API_URL || 'https://api.villakosh.in';
export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL || 'https://images.villakosh.in';
export const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || '';
export const HAS_CLERK_PUBLISHABLE_KEY = Boolean(CLERK_PUBLISHABLE_KEY && CLERK_PUBLISHABLE_KEY.trim());
